import { Helmet } from 'react-helmet'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

import SearchForm from './search-form'
import CategoriesSection from './categories-section'
import NewsletterForm from '../../components/newletter-form'

class CategoryListPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: ''
        };
    }

    handleSearch = (value) => {
        this.setState({
            searchValue: value.trim().toLowerCase()
        });
    }

    render() {
        const seo = this.props.query.playbook.seo, generic = this.props.query.playbook.social.generic[0], twitter = this.props.query.playbook.social.twitter[0]
        return (
            <div>
                <Helmet>
                    <title>Startup Guide - {seo.title?seo.title:"Categories"}</title>
                    <meta content={seo.description?seo.description:"Categorias"} name="description" />

                    <meta content="website" property="og:type" />
                    <meta content={generic&&generic.title?generic.title:"Categories"} property="og:title" />
                    <meta content={generic&&generic.description?generic.description:"Categorias"} property="og:description" />
                    <meta content={generic&&generic.image?generic.image:this.props.query.playbook.headerPicture} property="og:image" />
                    <meta property="og:url" content="https://startupguide.com/playbook"></meta>
                    <meta property="og:site_name" content="StartupGuide"></meta>

                    <meta name="twitter:card" content={twitter&&twitter.type.includes('Standard')?'summary':'summary_large_image'}></meta>
                    <meta name="twitter:site" content="@StartupGuideHQ"></meta>
                    <meta name="twitter:creator" content={twitter&&twitter.handle?twitter.handle:'@StartupGuideHQ'}></meta>
                    <meta name="twitter:title" content={twitter&&twitter.title?twitter.title:"Categorias"}></meta>
                    <meta name="twitter:description" content={twitter&&twitter.description?twitter.description:"Categorias"}></meta>
                    <meta name="twitter:image" content={twitter&&twitter.image?twitter.image:this.props.query.playbook.headerPicture}></meta>
                </Helmet>
                <div className="book-header">
                    <img alt=""
                        src={this.props.query.playbook.headerPicture}
                        width="1280"
                        className="image-55-copy"
                    />
                </div>
                <div className="trending-cities-section">
                    <div className="all-cities-header">
                        <div className="all-categories_tex">All Categories</div>
                        <div className="div-block-39">
                            <SearchForm
                                placeholder="Search the topic"
                                onChange={this.handleSearch}
                            />
                        </div>
                    </div>
                </div>

                <CategoriesSection
                    {...this.props}
                    query={this.props.query}
                    filter={this.state.searchValue}
                    seo={this.props.query.playbook.seo}
                />
                <NewsletterForm />
            </div>
        )
    }
}

const CategoryListFragment = createFragmentContainer(
    CategoryListPage,
    graphql`
        fragment categoryListPage_query on Query {
            playbook {
                headerPicture
                seo {
                    title
                    description
                }
                social {
                    twitter {
                        type
                        title
                        image
                        handle
                        description
                    }
                    generic {
                        title
                        image
                        description
                    }
                }
            }
            ...categoriesSection_query
        }
    `
)

export default (props) => <CategoryListFragment query={props} {...props} />
